import { getAndroidAppVersion } from "../../../shared/appInterface";
import { config } from "../../../shared/config";
import { CityType, NBPreferredLocationData } from "../types/step-four-types";
import { STEP_THREE_INITIAL_VALUES } from "./step-three-constants";

export const PREFERENCES_SKILLS_FORM_INITIAL_VALUE = {
  addedSkills: [],
  deletedSkills: [],
  customSkills: [],
}

export const PREFERENCES_PAGES = {
  BASE_ROUTE: "/preferences",
  LANGUAGES: "1",
  WORK_TYPE: "2",
  JOB_CITY: "3",
  JOB_TYPES: "4",
  DELIVERY_INFO: "delivery",
  TELECALLER_INFO: "telecaller",
  TIGER_EYE: "tigereye"
};

export const PREFERENCES_DEFAULT_VALUE = {
  skillsDetails: PREFERENCES_SKILLS_FORM_INITIAL_VALUE,
  languageDetails: {
    englishProficiency: -1,
    languagesKnown: [],
  },
  jobCategoryDetails: { jobCategories: [] },
  assessmentDetails: {
    telecaller: [],
    delivery: {
      drivingLicense: -1,
      bike: -1,
      rc: -1
    }
  },
  preferredJobCity: [{}] as CityType[],
  workTypePreferences: STEP_THREE_INITIAL_VALUES,
}

export const STEP_FIVE_INITIAL_VALUES = {
  jobCategories: [],
}

export const CATEGORY_IDS = {
  TELECALLER: 37,
  DELIVERY: 11,
  SALES_BD: 30
}

export const PREFERRED_CITY_DEFAULT_VALUE: CityType = {
  id: -1,
  name: "",
}

export const NB_PREFERRED_CITY_DEFAULT_VALUE: NBPreferredLocationData = {
  city_id: "-1",
  cluster_id: null,
  is_live:false,
  display_name: "",
}

export const PREFERRED_CITY_QUESTION_ID = config.questionIds.city;

export const EXPERIENCE_LEVEL_ID = {
  FRESHER: 1,
  EXPERIENCED: 2,
} as const;

export const CTA_STATE = {
  ACTIVE: "Active",
  INACTIVE: "Inactive"
} as const;

export const CITY_SECTION_LABELS = {
  SUGGESTED_CITIES: 'PREFERENCES.SUGGESTED_CITIES',
  ALL_CITIES: 'PREFERENCES.ALL_LIVE_CITIES',
  SEARCH_RESULTS: 'Search results'
}

export const questions = [
  {
      id: 0,
      title: "Driving License",
      key: "driving-license",
      question_id: 0,
      type: "docs"
  },
  {
      id: 1,
      title: "Bike",
      key: "Bike",
      question_id: 1,
      type: "assets"
  },
  {
      id: 2,
      title: "Car",
      key: "Car",
      question_id: 2,
      type: "assets"
  },
  {
    id: 3,
    title: "Auto",
    key: "Auto",
    question_id: 3,
    type: "assets"
  }, {
    id: 4,
    title: "PAN card",
    key: "pan-card",
    question_id: 4,
    type: "docs"
  }, {
    id: 5,
    title: "Aadhar card",
    key: "aadhar-card",
    question_id: 5,
    type: "docs"
  },
]

export const MAX_JOB_CATEGORY_SELECTIONS_ALLOWED = 8;
export const MAX_PREFERRED_CITIES_ALLOWED = getAndroidAppVersion() >= config.appVersionFeatureChecks.multiPreferredCity ? 3 : 1;
